import React, { PropsWithChildren, useLayoutEffect } from 'react';
import { useLocation } from 'react-router';
import { Redirect } from 'react-router-dom';

import { Spinner } from '@components/Spinner';
import { useAuthContext } from '@hooks';
import { loginUrl } from '@urls';
import { AUTH_REQUIRED_SEARCH, setPostLoginRedirectFromLocation } from '@utils/postLoginRedirect';

export const LoginRequired: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoggedIn, loading } = useAuthContext();
  const location = useLocation();

  useLayoutEffect(() => {
    if (loading || isLoggedIn) return;
    // Remember guarded URL for post-login return (pathname + search + hash)
    setPostLoginRedirectFromLocation(location.pathname, location.search, location.hash);
  }, [loading, isLoggedIn, location.pathname, location.search, location.hash]);

  return loading ? (
    <Spinner big />
  ) : isLoggedIn ? (
    <>{children}</>
  ) : (
    <Redirect
      to={{
        pathname: loginUrl,
        search: AUTH_REQUIRED_SEARCH,
        state: { authRequired: true },
      }}
    />
  );
};
